var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGallerySvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0091EA"
    },
    d: "M17.067,123.733v194.304l139.435-123.904c3.157-2.816,8.107-2.816,11.264,0l147.2,130.816 l54.101-61.781c3.243-3.669,9.557-3.669,12.8,0l44.8,51.2V123.733H17.067z M307.2,243.2c-18.859,0-34.133-15.275-34.133-34.133 s15.275-34.133,34.133-34.133c18.859,0,34.133,15.275,34.133,34.133S326.059,243.2,307.2,243.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CAF50"
    },
    d: "M426.667,340.309v116.224h-409.6V340.907l145.067-128.939l147.968,131.499 c1.621,1.451,3.925,2.133,6.144,2.133c2.304-0.171,4.437-1.195,5.888-2.901l53.333-60.928L426.667,340.309z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M494.933,38.4h-409.6c-9.387,0-17.067,7.68-17.067,17.067v17.067H51.2c-9.387,0-17.067,7.68-17.067,17.067v17.067H17.067 C7.68,106.667,0,114.347,0,123.733v332.8C0,465.92,7.68,473.6,17.067,473.6h409.6c9.387,0,17.067-7.68,17.067-17.067v-17.067H460.8 c9.387,0,17.067-7.68,17.067-17.067v-17.067h17.067c9.387,0,17.067-7.68,17.067-17.067v-332.8C512,46.08,504.32,38.4,494.933,38.4z  M426.667,456.533h-409.6V340.907l145.067-128.939l147.968,131.499c1.621,1.451,3.925,2.133,6.144,2.133 c2.304-0.171,4.437-1.195,5.888-2.901l53.333-60.928l51.2,58.539V456.533z M426.667,314.368l-44.8-51.2 c-3.243-3.669-9.557-3.669-12.8,0l-54.101,61.781l-147.2-130.816c-3.157-2.816-8.107-2.816-11.264,0L17.067,318.037V123.733h409.6 V314.368z M460.8,422.4h-17.067V123.733c0-9.387-7.68-17.067-17.067-17.067H51.2V89.6h409.6V422.4z M494.933,388.267h-17.067V89.6 c0-9.387-7.68-17.067-17.067-17.067H85.333V55.467h409.6V388.267z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2979FF"
    },
    d: "M494.933,55.467v332.8h-17.067V89.6c0-9.387-7.68-17.067-17.067-17.067H85.333V55.467H494.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2979FF"
    },
    d: "M460.8,89.6v332.8h-17.067V123.733c0-9.387-7.68-17.067-17.067-17.067H51.2V89.6H460.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M307.2,174.933c-18.859,0-34.133,15.275-34.133,34.133S288.341,243.2,307.2,243.2c18.859,0,34.133-15.275,34.133-34.133 S326.059,174.933,307.2,174.933z M307.2,226.133c-9.387,0-17.067-7.68-17.067-17.067S297.813,192,307.2,192 s17.067,7.68,17.067,17.067S316.587,226.133,307.2,226.133z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC107"
    },
    cx: 307.2,
    cy: 209.067,
    r: 17.067
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2979FF"
    },
    points: "401.067,123.733 401.067,285.107 426.667,314.368 426.667,123.733 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#388E3C"
    },
    points: "401.067,311.04 401.067,456.533 426.667,456.533 426.667,340.309 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallerySvgrepoCom);
export default __webpack_public_path__ + "static/media/gallery-svgrepo-com.1546e751e8a7549c5e8036a2f593790a.svg";
export { ForwardRef as ReactComponent };